export default {
  en: {
    title: 'Ai Topics',
    subtitle: 'List of topics.',
    form: {
      label: {
        label: 'Visible name',
        error: 'Enter a valid topic name.',
        hint: 'The topic name will be visible in analytics.',
      },
      identifier: {
        label: 'Topic ID',
        error: 'Please enter a topic id.',
        hint: 'This is the id of the topic and only can contains in lowercase and dash without spaces',
      },
      description: {
        label: 'Description',
        hint: 'Set the description of the topic, is important to describe correctly for the AI',
      },
    },
    messages: {
      success: 'Topic {action} successfully',
    }
  },
  es: {
    title: 'Topicos para IA',
    subtitle: 'Listado de tópicos para IA.',
    form: {
      label: {
        label: 'Nombre visible',
        error: 'Ingresa una nombre de tópico válido',
        hint: 'Nombre de la tópico que será visible en las analíticas',
      },
      identifier: {
        label: 'ID del tópico',
        error: 'Por favor ingrese el id de tópico',
        hint: 'Este es un id del tópico y solo debe contener minúsculas y guiones sin espacios',
      },
      description: {
        label: 'Descripción',
        hint: 'Establecezca la descripción del tópico, es importante describirlo correctamente para la IA',
      },
    },
    messages: {
      success: 'Tópico {action} correctamente',
    }
  },
  fr: {
    title: 'Sujets AI',
    subtitle: 'Liste des sujets.',
    form: {
      label: {
        label: 'Nom visible',
        error: 'Veuillez entrer un nom de sujet valide.',
        hint: 'Le nom du sujet sera visible dans les analyses.',
      },
      identifier: {
        label: 'ID du sujet',
        error: 'Veuillez entrer un ID de sujet.',
        hint: 'C\'est l\'ID du sujet et il ne peut contenir que des minuscules et des tirets sans espaces.',
      },
      description: {
        label: 'Description',
        hint: 'Définissez la description du sujet, il est important de décrire correctement pour l\'IA.',
      },
    },
    messages: {
      success: 'Sujet {action} avec succès',
    }
}

};
